/* Loaded Concept, 2026-10-30: the colour loop (a short clip of the real piece turning on its hook).
   2026-11-01 (Zsolt): it left the photo gallery and is now a "See it turning" button beside "Watch how it's made"
   (.kgs-loop-entry). It follows the colour on show, the last one still picked (kgs-v2.js sends "kgs:picks" after
   every pick, unpick, minus and add to cart), and hides when that colour was not filmed. The button opens the clip
   larger in the page's video dialog (kgs-v2.js). With nothing picked it follows the colour the page opened on.
   If this file loads after picks were made, it starts from the picker's data-kgs-last. */
(function () {
  function setup(box) {
    if (box.dataset.kgsLoopReady) return;
    box.dataset.kgsLoopReady = '1';
    let map = {};
    try { map = JSON.parse((box.querySelector('.kgs-colour-loop__map') || {}).textContent || '{}'); } catch (e) { map = {}; }
    if (map['*']) return; // one clip for every colour: always shown
    const btn = box.querySelector('.kgs-loop-open');
    if (!btn) return;
    const label = btn.dataset.dialogLabel || '';
    const landing = box.dataset.colour || '';
    const show = (name) => {
      const colour = name || landing;
      const entry = map[colour];
      if (!entry) { box.hidden = true; return; }
      box.hidden = false;
      btn.dataset.cardVideo = entry.src;
      btn.dataset.poster = entry.poster;
      btn.dataset.dialogLabel = label.replace(/, [^,]*, turning on its hook$/, ', ' + colour + ', turning on its hook');
    };
    const scope = box.closest('.js-product') || document;
    // this file can load after the shopper has already picked (quick buy): start from the picker's current state
    const picker = scope.querySelector('[data-kgs-last]');
    if (picker) {
      show(picker.dataset.kgsLast);
    } else {
      const one = [...scope.querySelectorAll('.kgs2-swatch[aria-pressed="true"]')].find((s) => !s.closest('[data-multi]'));
      if (one) show(one.dataset.name);
    }
    // several colours at once (the product page): the picks list is the truth
    scope.addEventListener('kgs:picks', (ev) => show(ev.detail && ev.detail.last));
    // one colour at a time (pages without several-colour picking): the swatch tapped
    scope.addEventListener('click', (ev) => {
      const sw = ev.target.closest && ev.target.closest('.kgs2-swatch');
      if (!sw || !scope.contains(sw) || sw.closest('[data-multi]') || sw.disabled) return;
      show(sw.dataset.name);
    });
  }
  function init() { document.querySelectorAll('[data-kgs-loop]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  // quick buy inserts a product after this file has loaded (main.js does not load it twice)
  document.addEventListener('on:quickbuy:after-open', init);
})();
